import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MyProfileService } from '../services/my-profile.service';
import { of, pipe } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertService } from '../services/alert.service';

@Injectable({ providedIn: 'root' })
export class FengGuard implements CanActivate {

    constructor(private router: Router,
      private activatedRoute: ActivatedRoute,
      private authService:AuthService,
      private myProfileService: MyProfileService,
      private alertService: AlertService) { }

      async canActivate() {

        let sessionId = this.activatedRoute.snapshot.queryParams['session'];
        let notFeng = false;
        if (sessionId == undefined || sessionId == '') {
          notFeng = true;
        }


        if(this.authService.getCustomer() !=null
        && this.authService.getCustomer()['fengIntegration'] != null &&
        this.authService.getCustomer()['fengIntegration'] == true && notFeng == true) {
          this.authService.logout();
        }
        return true;
      }


}
